import { render } from "./Observations.vue?vue&type=template&id=07014ee0&scoped=true"
import script from "./Observations.vue?vue&type=script&lang=js"
export * from "./Observations.vue?vue&type=script&lang=js"

import "./Observations.vue?vue&type=style&index=0&id=07014ee0&scoped=true&lang=scss"
import "./Observations.vue?vue&type=style&index=1&id=07014ee0&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07014ee0"]])

export default __exports__